import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccountRecord } from '@tassat/payments-definitions';
import React from 'react';

interface AddressCellRendererProps {
    value: { Account: string } | string;
    data: AccountRecord;
    nestedEntity?: string;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        whiteSpace: 'normal' as const
    },
    text: {
        width: '100%',
        whiteSpace: 'normal' as const,
        overflowWrap: 'anywhere',
        lineHeight: '18px'
    }
});

const AddressCellRenderer = (props: AddressCellRendererProps) => {
    const {
        value,
        data,
        nestedEntity
    } = props;

    const classes = muiStyles(props);
    const accountObject = nestedEntity ? data[nestedEntity] : typeof value !== 'string' && value.Account ? value : data;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            {value === '-' ?
                <span>{value}</span>
                : (
                    <>
                        <span className={classes.text}>{accountObject.Account}</span>
                    </>
                )}
        </Grid>
    );
};

export default AddressCellRenderer;